import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { WhatsappModule } from './_shared/whatsapp/whatsapp.module';
import { HomeButtonModule } from './_shared/home-button/home-button.module';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule, HttpClient, HttpHeaders } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AnalyticsService } from './_services/analytics.service';
import { TitleService } from './_services/title.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LangSelectorModule } from 'src/app/_shared/lang-selector/lang-selector.module';
import { RecaptchaModule } from './_shared/recaptcha/recaptcha.module';
import { JumbotronModule } from './_shared/jumbotron/jumbotron.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ClickToCallModule } from './_shared/click-to-call/click-to-call.module';
import { DatePipe } from '@angular/common';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal'
};

const cookieConfig:NgcCookieConsentConfig = {
  "cookie": {
    "domain": environment.appUrl
  },
  "position": "bottom-right",
  "theme": "classic",
  "palette": {
    "popup": {
      "background": "#000000",
      "text": "#ffffff",
      "link": "#ffffff"
    },
    "button": {
      "background": "#f1d600",
      "text": "#000000",
      "border": "transparent"
    }
  },
  "type": "info",
  "content": {
    "message": "...",
    "dismiss": "..",
    "deny": "...",
    "link": "...",
    "href": "#",
    "policy": "..."
  }
};

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, `${environment.apiUrl}/${environment.apiVersion}/translation/${environment.apiKey}/`, '.json');
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    IonicStorageModule.forRoot(),
    // Registramos el service worker extendido que importa internamente ngsw-worker.js
    ServiceWorkerModule.register('extended-sw.js', { enabled: environment.production }),
    NgcCookieConsentModule.forRoot(cookieConfig),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    LangSelectorModule,
    LangSelectorModule,
    RecaptchaModule,
    WhatsappModule,
    HomeButtonModule,
    JumbotronModule,
    SwiperModule,
    ClickToCallModule
    // PipesModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AnalyticsService,
    TitleService,
    DatePipe,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
